import Vue from 'vue';

/** Event bus for sending DNS events. */
const DnsEventBus = new Vue();

export default DnsEventBus;
